import { ReactNode, isValidElement } from 'react';

export function isReactNode<T>(node: T | ReactNode): node is ReactNode {
  return isValidElement(node);
}
